module.exports = __webpack_public_path__ + "img/ROROCCCO01240353.6e211257.png";